module.exports = __webpack_public_path__ + "static/media/bg-hongkong-univ-thumbnail.e3a93e4e.jpeg";